// IE 2026 10 31 / ODOO-5800 (заказ Игоря: Alt-довідка в одноколонковій формі; «Оформлення» — только у сработавшего правила)
// Строка «Marks» подсказки по Alt (AttrGrid.cellMarks / cellMarks_html) — чистые помощники без store / i18n (юнит tests/unit/cellMarkLine.test.mjs).
//
// formatMarkDetail — метка «Formatting» ставится, ТОЛЬКО когда условное оформление реально сработало на наведённой ячейке:
//   applied   — сработавшие правила (cf_appliedForCell: фронтовые cf_rules / заливка метрик / attr.cf_applied записи от бэка), [{ title }];
//   cfClasses — классы условного оформления бэка (мета ячейки _DLRow.cells[binding].cssClasses, MD.cssClass[binding]), учитываются те, что стоят на элементе;
//   elClasses — классы элемента ячейки; infoOf(name) → { title } реестра CSS-CLASS.
// Раньше запасной путь брал ВСЕ классы элемента из реестра — и структурные классы колонки / строки формы (cell-title «Title cell», cell-value «Value cell»,
// editable, readonly…) давали «Formatting» каждой ячейке. Возврат: null — метки нет; строка — подробность (имена правил / стилей, может быть '').
export function formatMarkDetail(applied, cfClasses, elClasses, infoOf) {
    const ap = (Array.isArray(applied) ? applied : []).filter(Boolean)
    if (ap.length) return ap.map(a => a.title).filter(Boolean).slice(0, 3).join(', ')
    const on = new Set(Array.isArray(elClasses) ? elClasses : [...(elClasses || [])])
    const names = []
    for (const c of (Array.isArray(cfClasses) ? cfClasses : [])) {
        for (const n of String(c || '').split(/\s+/)) {
            if (!n || !on.has(n)) continue
            const title = (typeof infoOf === 'function' ? infoOf(n)?.title : '') || ''
            if (title && !names.includes(title)) names.push(title)
        }
    }
    return names.length ? names.slice(0, 3).join(', ') : null
}

// markLineText — текст строки метки после « — »: короткое состояние (states[state], без точки в конце) и подробность (имя правила, дельта…).
// Объяснение «что это / зачем / что нажать» (what / why / click реестра uiHelp) в строку метки НЕ идёт — оно остаётся в реестре объяснений.
export function markLineText(nowText, detail) {
    const clause = String(nowText || '').trim().replace(/\.\s*$/, '')
    const tail = (detail === undefined || detail === null) ? '' : String(detail).trim()
    if (clause && tail) return `${clause} (${tail})`
    return clause || tail
}
